import { useQuery } from 'react-query';
import { BranchInspectionsService } from '../../services';

export const useInspectionScans = (id?: string) =>
  useQuery(
    ['branch-inspection-scans', id || ''],
    async () => {
      const result = await BranchInspectionsService.getScans(id!);
      if (result.status === 200) return result.data;
      throw new Error(result.data as string);
    },
    { enabled: !!id },
  );
